<app-page-breadcrumb pageTitle="Auditoría de Autenticación" />

<div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900 shadow-sm">
  <div class="p-6">

    <!-- Header -->
    <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
      <h2 class="text-lg font-semibold text-gray-800 dark:text-white">Eventos de Autenticación</h2>
      <button
        (click)="showFilters = !showFilters"
        class="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors">
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
        </svg>
        {{ showFilters ? 'Ocultar filtros' : 'Filtros' }}
        @if (activeFilterCount > 0) {
          <span class="ml-1 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-brand-500 px-1.5 text-[10px] font-semibold text-white">
            {{ activeFilterCount }}
          </span>
        }
      </button>
    </div>

    <!-- Filters -->
    @if (showFilters) {
      <div class="mb-6 rounded-xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-800/50">
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <!-- Username -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">
              Usuario @if (loadingUsers) { <span class="text-[10px] text-gray-400">(cargando...)</span> }
            </label>
            <select
              [(ngModel)]="filterUsername"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white">
              <option value="">Todos</option>
              @for (u of users; track u.id) {
                <option [value]="u.mail">{{ userLabel(u) }}</option>
              }
            </select>
          </div>
          <!-- Event Type -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Tipo de evento</label>
            <select
              [(ngModel)]="filterEventType"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white">
              <option value="">Todos</option>
              @for (et of eventTypeOptions; track et) {
                <option [value]="et">{{ getEventTypeLabel(et) }}</option>
              }
            </select>
          </div>
          <!-- Success -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Resultado</label>
            <select
              [(ngModel)]="filterSuccess"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white">
              <option value="">Todos</option>
              <option value="true">Exitoso</option>
              <option value="false">Fallido</option>
            </select>
          </div>
          <!-- IP -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Dirección IP</label>
            <input
              type="text"
              [(ngModel)]="filterIpAddress"
              (ngModelChange)="onFilterChange()"
              placeholder="192.168.1.100"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-500" />
          </div>
          <!-- Date From -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Desde</label>
            <input
              type="datetime-local"
              [(ngModel)]="filterDateFrom"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white" />
          </div>
          <!-- Date To -->
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-600 dark:text-gray-400">Hasta</label>
            <input
              type="datetime-local"
              [(ngModel)]="filterDateTo"
              (ngModelChange)="onFilterChange()"
              class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white" />
          </div>
        </div>
        <div class="mt-3 flex justify-end">
          <button
            (click)="clearFilters()"
            class="text-sm font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400 dark:hover:text-brand-300">
            Limpiar filtros
          </button>
        </div>
      </div>
    }

    <!-- Loading -->
    @if (loading) {
      <div class="flex items-center justify-center py-12">
        <div class="h-8 w-8 animate-spin rounded-full border-b-2 border-brand-500"></div>
        <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando...</span>
      </div>
    }

    <!-- Error -->
    @if (error) {
      <div class="mb-4 rounded-lg border border-error-200 bg-error-50 p-4 dark:border-error-500/20 dark:bg-error-500/10">
        <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    }

    <!-- Table -->
    @if (!loading && !error) {
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead>
            <tr class="border-b border-gray-200 text-left text-xs font-medium uppercase tracking-wide text-gray-500 dark:border-gray-700 dark:text-gray-400">
              <th class="py-3 px-4">Fecha</th>
              <th class="py-3 px-4">Usuario</th>
              <th class="py-3 px-4">Tipo de evento</th>
              <th class="py-3 px-4 text-center">Estado</th>
              <th class="py-3 px-4">IP</th>
              <th class="py-3 px-4">Razón de fallo</th>
              <th class="py-3 px-4">User Agent</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (log of logs; track log.id) {
              <tr class="transition hover:bg-gray-50 dark:hover:bg-gray-800/50">
                <td class="py-3 px-4 whitespace-nowrap text-gray-600 dark:text-gray-300">
                  {{ log.timestamp | date:'dd/MM/yyyy HH:mm:ss' }}
                </td>
                <td class="py-3 px-4 text-gray-800 dark:text-white">
                  {{ log.username }}
                </td>
                <td class="py-3 px-4">
                  <span class="rounded-full px-2.5 py-0.5 text-xs font-medium" [ngClass]="getEventTypeClass(log.eventType)" [title]="log.eventType">
                    {{ eventLabel(log) }}
                  </span>
                </td>
                <td class="py-3 px-4 text-center">
                  @if (log.success) {
                    <span class="inline-flex h-5 w-5 items-center justify-center rounded-full bg-green-100 dark:bg-green-500/10">
                      <svg class="h-3 w-3 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                      </svg>
                    </span>
                  } @else {
                    <span class="inline-flex h-5 w-5 items-center justify-center rounded-full bg-red-100 dark:bg-red-500/10">
                      <svg class="h-3 w-3 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                    </span>
                  }
                </td>
                <td class="py-3 px-4 text-gray-600 dark:text-gray-300 font-mono text-xs">
                  {{ log.ipAddress ?? '—' }}
                </td>
                <td class="py-3 px-4 max-w-xs truncate text-gray-500 dark:text-gray-400" [title]="log.failureReason ?? ''">
                  {{ failureReasonText(log) }}
                </td>
                <td class="py-3 px-4 max-w-[200px] truncate text-gray-400 dark:text-gray-500 text-xs" [title]="log.userAgent ?? ''">
                  {{ log.userAgent ?? '—' }}
                </td>
              </tr>
            }
            @empty {
              <tr>
                <td colspan="7" class="py-10 text-center text-gray-400 dark:text-gray-500">
                  No se encontraron eventos de autenticación.
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      @if (totalPages > 1) {
        <div class="mt-4 flex items-center justify-between border-t border-gray-200 pt-4 dark:border-gray-700">
          <p class="text-sm text-gray-500 dark:text-gray-400">
            Mostrando página {{ currentPage + 1 }} de {{ totalPages }}
            <span class="ml-1 text-xs">({{ totalElements }} registros)</span>
          </p>
          <div class="flex gap-2">
            <button
              (click)="loadLogs(currentPage - 1)"
              [disabled]="currentPage === 0"
              class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors">
              Anterior
            </button>
            <button
              (click)="loadLogs(currentPage + 1)"
              [disabled]="currentPage + 1 >= totalPages"
              class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors">
              Siguiente
            </button>
          </div>
        </div>
      }
    }
  </div>
</div>
